import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { TbAlertTriangle, TbBrandWhatsapp, TbX } from 'react-icons/tb';
import Photo from './Photo';
import { LAWYERS, OFFICE, getWhatsAppLink } from '../data/escritorio';
import './LawyerChooser.css';

// Caixa "Com qual advogado deseja falar?": cada opção abre o WhatsApp do advogado escolhido.
const LawyerChooser = ({ open, onClose }) => {
  const firstOptionRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    firstOptionRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="nvh-chooser-backdrop" onClick={onClose}>
      <div
        className="nvh-chooser"
        role="dialog"
        aria-modal="true"
        aria-labelledby="nvh-chooser-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="nvh-chooser-head">
          <div>
            <span className="nvh-chooser-eyebrow">Atendimento pelo WhatsApp</span>
            <h2 id="nvh-chooser-title">Com qual advogado deseja falar?</h2>
          </div>
          <button type="button" className="nvh-chooser-close" onClick={onClose} aria-label="Fechar">
            <TbX aria-hidden="true" />
          </button>
        </div>
        <div className="nvh-chooser-options">
          {LAWYERS.map((lawyer, index) => (
            <a
              key={lawyer.email}
              ref={index === 0 ? firstOptionRef : undefined}
              className="nvh-chooser-option"
              href={getWhatsAppLink(lawyer.phone)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
            >
              <Photo webp={lawyer.photoWebp} png={lawyer.photo} alt="" className="nvh-chooser-photo" loading="eager" />
              <span className="nvh-chooser-text">
                <strong>{lawyer.name}</strong>
                <span>{lawyer.oab} · {lawyer.phone}</span>
              </span>
              <TbBrandWhatsapp className="nvh-chooser-wpp" aria-hidden="true" />
            </a>
          ))}
        </div>
        <p className="nvh-chooser-warning">
          <TbAlertTriangle aria-hidden="true" />
          <span>
            Estes números e o {OFFICE.phone} são os únicos do escritório. Não pedimos dinheiro, senhas ou dados por
            mensagem.{' '}
            <Link to="/golpe-do-falso-advogado" onClick={onClose}>
              Saiba mais
            </Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default LawyerChooser;
